import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Redirect non-admin users from admin routes
  if (adminOnly && !user.isAdmin) {
    return <Navigate to="/dashboard" />;
  }

  // Redirect admin users to admin dashboard from regular dashboard
  if (!adminOnly && user.isAdmin && window.location.pathname === '/dashboard') {
    return <Navigate to="/admin" />;
  }

  return children;
};

export default PrivateRoute; 